import React from 'react';
import { Box, Typography } from '@mui/material';
import ReviewerFeedbackAction from './ReviewerFeedbackAction';

const ReviewerFeedbackActionList = ({ 
  actionType,
  assignment,
  employeeId,
  currentReviewerId
}) => {
  if (!assignment || !assignment.reviewers) {
    return null;
  }

  // Get all reviewers except the current one, sorted by order
  const previousReviewers = assignment.reviewers
    .filter(reviewer => 
      reviewer.id !== currentReviewerId && 
      reviewer.feedbackAttachedAt && // Only show reviewers who have submitted feedback
      reviewer.feedbackOnDemand && 
      reviewer.feedbackOnDemand[`${actionType}Comments`]
    )
    .sort((a, b) => a.order - b.order);

  if (previousReviewers.length === 0) {
    return null;
  }

  return (
    <Box sx={{ mb: 3 }}>
      <Typography variant="subtitle2" sx={{ mb: 2, color: 'text.secondary' }}>
        Previous Reviewers' {actionType.charAt(0).toUpperCase() + actionType.slice(1)} Actions
      </Typography>
      {previousReviewers.map(reviewer => (
        <ReviewerFeedbackAction
          key={`${reviewer.id}-${actionType}`}
          reviewer={reviewer}
          comments={reviewer.feedbackOnDemand[`${actionType}Comments`]}
          actionType={actionType}
          employeeId={employeeId}
          assignment={assignment}
        />
      ))}
    </Box>
  );
};

export default ReviewerFeedbackActionList; 